import { AlertDialog, Button } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface RevokeConnectionDialogProps {
  appName: string
  connectedDate: string
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading: boolean
}

export const RevokeConnectionDialog = ({
  appName,
  connectedDate,
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}: RevokeConnectionDialogProps): JSX.Element => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialog.Content>
      <AlertDialog.Title>Revoke Access</AlertDialog.Title>
      <AlertDialog.Description>
        Are you sure you want to revoke access for {appName}, connected{' '}
        {connectedDate}? This connection will immediately stop being able to
        read or change your Buffer data. You can connect again at any time.
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <AlertDialog.Cancel>
          <Button variant="tertiary">Cancel</Button>
        </AlertDialog.Cancel>

        <Button variant="critical" onClick={onConfirm} loading={isLoading}>
          Revoke Access
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Content>
  </AlertDialog>
)
